export function getWindowScreen(): { availHeight: number; availWidth: number } {
    return window.screen;
}
